import i18n from "i18next";

import { LoaderFunction } from "react-router-dom";

import BroadcastRequests from "@/api/broadcast/broadcast.requests.ts";
import { queryClient } from "@/api/query-client.tsx";
import { BROADCAST_KEYS } from "@/hooks/api/broadcast.hooks.ts";
import { lang } from "@/utils/funcs.ts";

export const broadcastCategoriesLoader: LoaderFunction = async () => {
  const categoriesCache = queryClient.getQueryData(BROADCAST_KEYS.broadcastsCategory(i18n.language, false));
  if (categoriesCache) return categoriesCache;

  const profileAge = localStorage.getItem("splay:profileAge");
  const isKids: boolean = profileAge ? parseInt(profileAge) < 16 : false;

  return queryClient.fetchQuery({
    queryKey: BROADCAST_KEYS.broadcastsCategory(lang, isKids),
    queryFn: () => BroadcastRequests.getBroadcastCategories(isKids),
    staleTime: 1000 * 60 * 15,
  });
};
